import { theme } from '@Guidelines/Theme/theme';
import { css } from '@emotion/react';
import type * as React from 'react';
import { Skeleton } from '@verclam/ui-kit';

const pageStyle = css`
	display: flex;
	flex-direction: column;
	gap: 1.5rem;
`;

const headerStyle = css`
	display: flex;
	flex-direction: column;
	gap: 0.75rem;
`;

/** Same shape as the loaded page: the header, then one card. */
const InterviewUploadSkeleton: React.FC = () => (
	<div css={pageStyle} aria-busy="true">
		<div css={headerStyle}>
			<Skeleton width="14rem" height="0.875rem" animation="wave" />
			<Skeleton width="28rem" height="2.75rem" animation="wave" />
		</div>
		<Skeleton height="10rem" borderRadius={theme.radii.xlarge} animation="wave" />
	</div>
);

export default InterviewUploadSkeleton;
